const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLForm = require('app/graphql/Form');

class RangeForm extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitRestaurantSupplierAssociationRanges',
            'restaurant': null,
            'supplier': null,
            'onChange': function(){},
            'onClickBack': function(form){}
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.onClickBack = this.onClickBack.bind(this);
        this.onClickToggleAll = this.onClickToggleAll.bind(this);

        this.restaurant = this.settings.restaurant;
        this.supplier = this.settings.supplier;
        this.changed = false;

        this.$form = $('<form/>')
        .addClass('restaurant-supplier-range-form');

        this.loadData();

        super.initialize();
    }

    hasChange(){
        return this.changed;
    }

    getRestaurant(){
        return this.restaurant;
    }

    getSupplier(){
        return this.supplier;
    }

    getForm(){
        return this.$form;
    }

    loadData(){
        var self = this;

        this.$form
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildSupplierAssociationQuery(),
            this.buildRangeQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSupplierAssociationQuery(){
        var self = this;

        let parameters = {
            'restaurant': this.restaurant.id,
            'supplier': this.supplier.id,
        };

        let fields = [
            'rangeAssociations { range { id } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantSupplierAssociation',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    buildRangeQuery(){
        var self = this;

        let parameters = {
            'first': 10000,
            'orderBy': 'name',
            'dir': "ASC",
            'filter': {
                'root': true,
                'deliveredBySupplier': this.supplier.id,
            }
        };

        let fields = [
            'id',
            'name',
            'suppliers { id }',
            'childs { id name suppliers { id } parent { id } childs { id name suppliers { id } parent { id } childs { id name suppliers { id } parent { id } } } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProductRanges',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }

    fillForm(data){
        var self = this;
        this.association = data.restaurantSupplierAssociation;
        this.ranges = data.supplierProductRanges.edges;
        
        this.$btnBack = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-primary')
        .append(
            $('<i/>')
            .addClass('fa fa-arrow-left')
        )
        .append(' ')
        .append(window.translate('back'))
        .on('click',this.onClickBack)


        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success')
        .append(
            $('<i/>')
            .addClass('fa fa-check text-white')
        )
        .append(' ')
        .append(window.translate('app.restaurant.show.tabs.supplier.range.submit.label'));


        this.$btnToggleAll = $('<button/>')
        .attr("type","button")
        .addClass('btn btn-secondary')
        .append(window.translate('app.restaurant.show.tabs.supplier.range.toggleAll.label'))
        .on("click",this.onClickToggleAll);

        this.$form
        .html('')
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-end mb-2')
            .append(
                this.$btnToggleAll
            )
        )
        .append(this.buildInputs())
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2 d-flex justify-content-start')
                .append(
                    this.$btnBack
                )
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2 d-flex justify-content-end')
                .append(
                    this.$btnSubmit
                )
            )
        );

        return this.$form;
    }

    buildInputs(){
        var self = this;    
        let $box = $('<div/>');


        for(var r in this.ranges){
            let range = this.ranges[r];
            let $item = this.buildRangeInput(range.node);

            $box.append($item);
        }

        return $box;
    }

    isRangeEnable(range){
        for(var i in this.association.rangeAssociations){
            let rangeAssociation = this.association.rangeAssociations[i];
            if(range.id == rangeAssociation.range.id){
                return true;
            }
        }
        return false;
    }

    buildRangeInput(range){
        var self = this;
        let $item = $('<div/>');
        let id = "range"+range.id;

        // FIELD range
        let $rangeLabel = $('<label/>')
        .attr('for',id)
        .addClass('form-check-label')
        .append(range.name);
        this.$rangeInput = $('<input/>')
        .attr('id',id)
        .attr('data-id',range.id)
        .attr('name','ranges[]')
        .attr('type','checkbox')
        .addClass('range-checkbox')
        .addClass('form-check-input form-check-input-checked-success form-check-input-unchecked-danger')
        .val(range.id)
        .on("change",function(){
            self.onChange();
            let checked = $(this).is(':checked');

            if(range.parent){
                self.updateParent(range.parent.id,checked);
            }
        });
        if(this.isRangeEnable(range)){
            this.$rangeInput.prop('checked',true);
        }

        let $rangeSwitch = $('<div/>')
        .addClass('form-check form-switch')
        .append(this.$rangeInput)
        .append($rangeLabel);

        $item.append(
            $('<div/>')
            .addClass('form-group')
            .append($rangeSwitch)
        );

        if(range.parent == null){
            $item.addClass('bg-light p-2 mb-2')
        }else{
            this.$rangeInput.attr("data-parent",range.parent.id);
        }

        let showThisRange = this.isRangeDelivredBySupplier(range);

        if(range.childs && range.childs.length > 0){
            let $childContainer = $('<div/>')
            .addClass('ms-4');

            let orderedChilds = window.sortArrayOfObjectByProperty(range.childs,"name");
            for(var c in orderedChilds){
                let child = orderedChilds[c];
                let $child = this.buildRangeInput(child);
                if(child == ''){
                }else{
                    showThisRange = true;
                    $childContainer.append($child)
                }
            }

            $item.append($childContainer);
        }

        if(!showThisRange){
            return '';
        }
        return $item;
    }

    isRangeDelivredBySupplier(range){
        for(var s in range.suppliers){
            let supplier = range.suppliers[s];
            if(supplier.id == this.supplier.id){
                return true;
            }
        }
        return false;
    }


    onDOMReady(){
        super.onDOMReady();
    }

    getFields(){
        let fields = super.getFields();
        return fields;
    }
    
    getVariables(){
        let variables = {};

        variables.restaurant = {
            'value': this.restaurant.id,
            'type': 'Int!'
        };

        variables.supplier = {
            'value': this.supplier.id,
            'type': 'Int!'
        };

        return variables;
    }

    onClickBack(event){
        this.settings.onClickBack(this);
    }

    onChange(){
        this.changed = true;
        this.settings.onChange();
    }

    updateParent(id,checked){
        let $childsChecked = $('.range-checkbox[data-parent="'+id+'"]:checked');
        let $parent = $('.range-checkbox[data-id="'+id+'"]');
        if(checked){
            $parent.prop('checked',true);
        }else if($childsChecked.length <= 0){
            $parent.prop('checked',false);
        }
        if($parent.data('parent')){
            let parent = $parent.data('parent');
            this.updateParent(parent,checked);
        }
    }

    onClickToggleAll(event){
        if($('.range-checkbox:checked').length > 0){
            $('.range-checkbox').prop('checked',false);
        }else{
            $('.range-checkbox').prop('checked',true);
        }
        this.changed = true;
    }

    onSuccess(data){
        this.changed = false;
        super.onSuccess(data);
    }
}

module.exports = RangeForm;

